const VIDEO_TYPES = {
	CREATE: 'VIDEOS/CREATE',
	UPDATE: 'VIDEOS/UPDATE',
	REMOVE: 'VIDEOS/REMOVE',
	MARK_SEEN: 'VIDEOS/MARK_SEEN',
	UPDATE_ORDER: 'VIDEOS/UPDATE_ORDER',
	HANDLE_ACTIVATION: 'VIDEOS/HANDLE_ACTIVATION',
};

export default VIDEO_TYPES;
